import { render } from "./DomainStat.vue?vue&type=template&id=25b9ab42&scoped=true"
import script from "./DomainStat.vue?vue&type=script&lang=js"
export * from "./DomainStat.vue?vue&type=script&lang=js"

import "./DomainStat.vue?vue&type=style&index=0&id=25b9ab42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b9ab42"]])

export default __exports__